<!-- @format -->

<!--
 * Datei: Footer.vue
 * Projekt: novagraphix_nuxt_template
 * Erstellt: 20.08.2019, 15:34:41
 * Autor: Stephan Jess
 * -----
 * Zuletzt bearbeitet: 20.08.2019 15:34:41
 * von:  Stephan Jess (s.jess@novagraphix.de>)
 * -----
 * Copyright (c) 2019 Novagraphix GmbH & Co. KG
 * -----
 -->

<template>
  <div>
    <div
      class="flex flex-col md:flex-row sm:justify-center mb-2 text-base navpoints mb-4 sm:mb-0 text-white font-robotoCondensed font-bold"
    >
      <a href="https://www.nfp-md.de/" target="_blank">NFP HOME</a>
      <a
        href="#"
        class="btn_modal"
        data-rel="#modal_press"
        @click.prevent="emitPressClick()"
        >PRESSE</a
      >
      <a href="http://impressum.nfp.de/" target="_blank">IMPRESSUM</a>
      <a href="http://datenschutz.nfp.de/" target="_blank">DATENSCHUTZ</a>
      <a
        v-if="teilnahmebedingung != 'leer'"
        :href="'/' + teilnahmebedingung"
        target="_blank"
        >TEILNAHMEBEDINGUNGEN</a
      >
    </div>
    <div class="relative mt-2 mb-4 text-xs text-white font-robotoCondensed">
      &copy; 2019 NFP marketing & distribution. Alle Rechte vorbehalten. made by
      <a
        class="text-white hover:text-black"
        href="http://www.novagraphix.de"
        target="_blank"
        >novagraphix</a
      >
    </div>
    <ul
      v-if="$config.kinoservice.display && $config.verantwortlich === 'NFP'"
      class="text-center list-reset lg:hidden mb-4 text-xl md:text-2xl font-bold font-roboto"
    >
      <li class="inline-block mr-2">
        <a
          class="m-0 uppercase text-white"
          :href="$config.kinoservice.finder + $config.kinoservice.slug"
          target="_blank"
          >Kinofinder</a
        >
      </li>
      <li class="inline-block ml-2">
        <a
          class="m-0 uppercase text-white"
          :href="$config.kinoservice.alert + $config.kinoservice.id"
          target="_blank"
          >Filmwecker</a
        >
      </li>
    </ul>
    <PressModal />
  </div>
</template>

<script>
  import { EventBus } from '@/plugins/event-bus.js'
  import PressModal from '@/components/Base/Elements/Modals/Press.vue'

  export default {
    components: {
      PressModal,
    },
    props: {
      teilnahmebedingung: {
        type: String,
        default: 'leer',
      },
    },
    methods: {
      emitPressClick() {
        /* eslint-disable-next-line no-undef */
        EventBus.$emit('pressmodal')
      },
    },
  }
</script>
